"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaveOrUpdateWidgetAlert = void 0;
// (C) 2020-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var utils_1 = require("../utils");
/**
 * Hook allowing to save a widget alert
 * @param config - configuration of the hook
 * @internal
 */
function useSaveOrUpdateWidgetAlert(_a) {
    var widgetAlert = _a.widgetAlert, backend = _a.backend, workspace = _a.workspace, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    utils_1.backendInvariant(effectiveBackend, "useSaveOrUpdateWidgetAlert");
    utils_1.workspaceInvariant(effectiveWorkspace, "useSaveOrUpdateWidgetAlert");
    var promise = widgetAlert
        ? function () {
            return sdk_backend_spi_1.isWidgetAlert(widgetAlert)
                ? effectiveBackend.workspace(effectiveWorkspace).dashboards().updateWidgetAlert(widgetAlert)
                : effectiveBackend.workspace(effectiveWorkspace).dashboards().createWidgetAlert(widgetAlert);
        }
        : null;
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
        widgetAlert,
    ]);
}
exports.useSaveOrUpdateWidgetAlert = useSaveOrUpdateWidgetAlert;
//# sourceMappingURL=useSaveOrUpdateWidgetAlert.js.map